import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Form, Button } from "react-bootstrap";
import DashBoardImageSlider from "../../components/cards/DashboardImageSlider";
import TotalGroupsRecord from "./TotalGroupsRecord";
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";

export default function GroupDashboard() {
  const [formState, setFormState] = useState({
    ppi: null,
    group: null,
    donor: null,
    business_donor: null,
    from: "",
    to: "",
  });

  const [error, setError] = useState("");
  const [data, setData] = useState(null); // Stores all identifiers
  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  const { t } = useContext(TranslatorContext);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedState = { ...formState, [name]: value };
    setFormState(updatedState);

    const { from, to } = updatedState;
    if (
      (from && to && new Date(to) >= new Date(from)) ||
      (!from && !to)
    ) {
      setError("");
    }
  };

  const handleApplyFilter = async () => {
    const { from, to } = formState;

    if (!from && !to) {
      setError("Please enter From Date and To Date.");
      return;
    }
    if (from && !to) {
      setError("Please select a 'To Date' when 'From Date' is chosen.");
      return;
    }
    if (!from && to) {
      setError("Please select a 'From Date' when 'To Date' is chosen.");
      return;
    }
    if (from && to && new Date(to) < new Date(from)) {
      setError("'To Date' cannot be earlier than 'From Date'.");
      return;
    }

    setError("");
    try {
      const params = {};
      if (from) params.from = from;
      if (to) params.to = to;

      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/act-group-dashboard",
        { params }
      );
      setData(response.data.data);
    } catch (error) {
      console.error("Error applying filter:", error);
    }
  };

  const handleClearFilter = async () => {
    try {
      setFormState({
        ...formState,
        from: "",
        to: "",
      });
      setError("");
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/act-group-dashboard"
      );
      setData(response.data.data);
    } catch (error) {
      console.error("Error clearing filter:", error);
    }
  };

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL + "/act-group-dashboard"
        );
        setData(response.data.data);
        console.log(response.data.data, "act-groups-dashboard");
      } catch (error) {
        console.log(error, "act-groups-dashboard");
      }
    };
    fetchData();
  }, [AuthToken]);

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">ACT Groups</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link
                    to="#"
                    className="mc-breadcrumb-link"
                    style={{ color: "#077834" }}
                  >
                    {t("home")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">ACT Groups Dashboard</li>
              </ul>
            </div>
          </div>
        </Col>

      <Col xl={12}>
  <div className="mc-card">
    <div className="mc-breadcrumb" style={{ marginBottom: "10px" }}>
      <h3 className="mc-breadcrumb-title">SELECT FILTER RANGE DATA</h3>
    </div>
    <Row className="align-items-center g-3">
      <Col md="auto">
        <Form.Label className="mb-0">From:</Form.Label>
      </Col>
      <Col md={3}>
        <Form.Control
          type="date"
          name="from"
          value={formState.from}
          onChange={handleChange}
        />
      </Col>

      <Col md="auto">
        <Form.Label className="mb-0">To:</Form.Label>
      </Col>
      <Col md={3}>
        <Form.Control
          type="date"
          name="to"
          value={formState.to}
          onChange={handleChange}
        />
      </Col>

      <Col md="2">
        <Button
          onClick={handleApplyFilter}
          style={{
            backgroundColor: "#077834",
            fontWeight: "bold",
            fontSize: "12px",
          }}
        >
          Apply Filter
        </Button>
      </Col>
      <Col md="2">
        <Button
          onClick={handleClearFilter}
          className="bg-secondary"
          style={{ fontWeight: "bold", fontSize: "12px" }}
        >
          Clear Filter
        </Button>
      </Col>
    </Row>

    {error && (
      <div className="text-danger mt-2" style={{ fontSize: "13px" }}>
        {error}
      </div>
    )}
  </div>
</Col>


        <Col xs={12} xl={4}>
          <DashBoardImageSlider />
        </Col>

        <Col xs={12} xl={8}>
          <Row xs={1} sm={2}>
            {data ? <TotalGroupsRecord data={data} /> : <></>}
          </Row>
        </Col>
      </Row>
    </PageLayout>
  );
}
